const MicroModal = require('micromodal').default;

class StaffList extends HTMLElement {

	constructor() {
		super();
	}

	connectedCallback() {
		MicroModal.init({
			awaitCloseAnimation: true,
			disableFocus: true,
		});
		this.attachImageBioClickHandlers();
	}

	get profilesWithBio() {
		return this.querySelectorAll('.staff-list__profile[data-has-bio="true"]');
	}

	attachImageBioClickHandlers() {
		for (const profileWithBio of this.profilesWithBio) {
			const openModalButtonElement = profileWithBio.querySelector('.staff-list__open-modal-button');
			const imgElement = profileWithBio.querySelector('.staff-list__profile-image img');
			if (openModalButtonElement && imgElement) {
				imgElement.addEventListener('click', () => {
					openModalButtonElement.click();
				});
			}
		}
	}

}

customElements.define('staff-list', StaffList, {extends: 'section'});